webpackJsonp([254572558124955],{

/***/ 804:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"algolia":{"appId":"F1F6HVYURM","searchOnlyApiKey":"6707a3e190b4b51c9786669fff61f338","indexName":"CONTENT"}}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---search-d821b6314dc2fad63b2d.js